/*
 * @Description:
 * @Author: Mankeung
 * @Date: 2021-07-10 14:49:27
 * @LastEditors: Mankeung
 * @LastEditTime: 2021-07-15 14:38:18
 */
export default [
	{
		path: "testOrder",
		name: "TEST_ORDER",
		meta: {
			title: "测评订单",
			icon: "",
			cache: "showCache",
			isNav: true,
		},
		component: () => import("@/views/order/testOrder.vue"),
	},
	{
		path: "testOrderList",
		name: "TEST_ORDER_LIST",
		meta: {
			title: "测评订单列表",
			icon: "",
			cache: "showCache",
			isNav: true,
		},
		component: () => import("@/views/order/testOrderList.vue"),
	},
	{
		path: "meditationOrder",
		name: "MEDITATION_ORDER",
		meta: {
			title: "冥想订单",
			icon: "",
			cache: "showCache",
			isNav: true,
		},
		component: () => import("@/views/order/meditationOrder.vue"),
	},
	{
		path: "internationalTestOrder",
		name: "INTERNATIONAL_TEST_ORDER",
		meta: {
			title: "测评订单",
			icon: "",
			cache: "showCache",
			isNav: true,
		},
		component: () => import("@/views/order/internationalTestOrder.vue"),
	},
	{
		path: "vipOrder",
		name: "VIP_ORDER",
		meta: {
			title: "会员订单",
			icon: "",
			cache: "showCache",
			isNav: true,
		},
		component: () => import("@/views/order/vipOrder.vue"),
	},
	{
		path: "payOrder",
		name: "PAY_ORDER",
		meta: {
			title: "支付订单",
			icon: "",
			cache: "showCache",
			isNav: true,
		},
		component: () => import("@/views/order/payOrder.vue"),
	},
	{
		path: "paySecondOrder",
		name: "SECOND_PAY_ORDER",
		meta: {
			title: "二转支付订单",
			icon: "",
			cache: "showCache",
			isNav: true,
		},
		component: () => import("@/views/order/paySecondOrder.vue"),
	},
	{
		path: "payFlowOrder",
		name: "FLOW_PAY_ORDER",
		meta: {
			title: "订阅流水",
			icon: "",
			cache: "showCache",
			isNav: true,
		},
		component: () => import("@/views/order/payFlowOrder.vue"),
	},
	{
		path: "subscription",
		name: "SUBSCRIPTION_LIST",
		meta: {
			title: "订阅管理",
			icon: "",
			cache: "showCache",
			isNav: true,
		},
		component: () => import("@/views/order/subscription.vue"),
	},
	{
		path: "orderRefund",
		name: "ORDER_REFUND",
		meta: {
			title: "退款管理",
			icon: "",
			cache: "showCache",
			isNav: true,
		},
		component: () => import("@/views/order/orderRefund.vue"),
	},
	{
		path: "channelCallBack",
		name: "CHANNEL_CALLBACK",
		meta: {
			title: "渠道回调",
			icon: "",
			cache: "showCache",
			isNav: true,
		},
		component: () => import("@/views/order/channelCallBack.vue"),
	},
	{
		path: "ExportTask",
		name: "ExportTask",
		meta: {
			title: "导出任务",
			icon: "",
			cache: "showCache",
			isNav: true,
		},
		component: () => import("@/views/order/ExportTask.vue"),
	},
	{
		path: "AncientChineseLiterature",
		name: "AncientChineseLiterature",
		meta: {
			title: "国学订单",
			icon: "",
			cache: "showCache",
			isNav: true,
		},
		component: () => import("@/views/order/AncientChineseLiterature.vue"),
	},
	{
		path: "TarotOrder",
		name: "TarotOrder",
		meta: {
			title: "塔罗订单",
			icon: "",
			cache: "showCache",
			isNav: true,
		},
		component: () => import("@/views/order/TarotOrder.vue"),
	},

	//详情页面 -all
	{
		path: "orderDetail",
		name: "ORDER_DETAIL",
		meta: {
			title: "详情",
			icon: "",
			isNav: false,
		},
		component: () => import("@/views/order/detailPage.vue"),
	},
	{
		path: "testOrderDetail",
		name: "TEST_ORDER_DETAIL",
		meta: {
			title: "测评订单详情",
			icon: "",
			isNav: false,
		},
		component: () => import("@/views/order/detailPage/testOrderDetail.vue"),
	},
	{
		path: "secondOrderDetail",
		name: "SECOND_ORDER_DETAIL",
		meta: {
			title: "二转详情",
			icon: "",
			isNav: false,
		},
		component: () => import("@/views/order/secondOrderDetailPage.vue"),
	},
	{
		path: "internationalDetailPage",
		name: "INTERNATIONAL_DETAIL_PAGE",
		meta: {
			title: "详情",
			icon: "",
			isNav: false,
		},
		component: () => import("@/views/order/internationalDetailPage.vue"),
	},
];
